type NativeBackGuard = () => void
let nativeBackGuard: NativeBackGuard | undefined
const captureBackGuards: NativeBackGuard[] = []

export function registerCaptureBackGuard(guard: NativeBackGuard): () => void {
  captureBackGuards.push(guard)
  return () => {
    const index = captureBackGuards.lastIndexOf(guard)
    if (index >= 0) captureBackGuards.splice(index, 1)
  }
}
let historyGuard: ((event: PopStateEvent) => void) | undefined

// Imported by the root Back provider before router effects register their listeners.
// Window-targeted popstate listeners run in registration order, even with capture.
if (typeof window !== "undefined") {
  window.addEventListener("popstate", event => historyGuard?.(event), true)
}

export function registerAnsweringHistoryGuard(guard: (event: PopStateEvent) => void): () => void {
  historyGuard = guard
  return () => { if (historyGuard === guard) historyGuard = undefined }
}

/** The answering route owns the decision; native Back must not flush or navigate first. */
export function registerAnsweringLeaveGuard(guard: NativeBackGuard): () => void {
  nativeBackGuard = guard
  return () => { if (nativeBackGuard === guard) nativeBackGuard = undefined }
}

export function delegateAnsweringBack(): boolean {
  const captureGuard = captureBackGuards.at(-1)
  if (captureGuard) { captureGuard(); return true }
  if (!nativeBackGuard) return false
  nativeBackGuard()
  return true
}
